import { Text } from "@mantine/core";
import {
  type DataTableColumn,
  type DataTableProps,
  DataTable as MantineDataTable,
} from "mantine-datatable";
import { useState } from "react";
import { FaArrowsAltH } from "react-icons/fa";

import { useResponsive } from "@/hooks/media";
import { H2 } from "../title";
import styles from "./_css/DataTable.module.css";

type Props<T> = {
  columns: DataTableColumn<T>[];
  title?: string;
  description?: string;
  /** スクロールヒントを表示するかどうか（デフォルト: true） */
  showScrollHint?: boolean;
} & DataTableProps<T>;

export function DataTable<T>(props: Props<T>) {
  const {
    title,
    description,
    columns,
    showScrollHint = true,
    ...dataTableProps
  } = props;
  const { isMobile } = useResponsive();
  const [hideHint, setHideHint] = useState(false);

  // スクロールしたらヒントを非表示
  const handleScroll = () => {
    if (!hideHint) {
      setHideHint(true);
    }
  };

  const defaultOption: Omit<DataTableProps<T>, "columns"> = {
    striped: true,
    verticalSpacing: isMobile ? "xs" : "sm",
    fz: "sm",
    horizontalSpacing: isMobile ? "xs" : "md",
    minHeight: 100,
  };
  const option = Object.assign({}, defaultOption, dataTableProps);

  return (
    <div className={styles.root}>
      {title && (
        <H2 pt="lg" px="lg">
          {title}
        </H2>
      )}
      {description && (
        <Text px="lg" c="gray">
          {description}
        </Text>
      )}
      {(title || description) && (
        <Text
          pt="lg"
          style={{ borderBottom: "1px solid rgb(222, 226, 230)" }}
        ></Text>
      )}
      <MantineDataTable {...option} columns={columns} onScroll={handleScroll} />
      {showScrollHint && !hideHint && (
        <div className={styles.scrollHint}>
          <FaArrowsAltH className={styles.scrollHintIcon} />
          <span>横スクロール</span>
        </div>
      )}
    </div>
  );
}
